import {
  ADD_TO_CART,
  SUBTRACT_FROM_CART,
  REMOVE_FROM_CART,
  CLEAR_CART,
  CHANGE_FREQUENCY,
  TOGGLE_SUBSCRIPTION,
} from "../actions/action-types";

export default function cartReducer(state, action) {
  let newCart = [...state];
  //console.log("newCart:", newCart);
  // check if adding an item that's already in the cart
  let existingIndex;
  if (action.payload) {
    existingIndex = state.findIndex((item) => {
      const sameVariant = item.variant.id === action.payload.variant.id;

      const itemHasSub = !!item.subscription;
      const payloadHasSub = !!action.payload.subscription;
      if (itemHasSub && payloadHasSub) {
        // Never merge subscriptions
        return false;
      }
      if (!itemHasSub && !payloadHasSub) {
        // Merge regular items
        //console.log("sameVariant:", sameVariant);
        return sameVariant;
      }
      // Otherwise, don't merge
      return false;
    });
  }
  //console.log("existingIndex:", existingIndex);

  // update cart state (context) and local storage function
  const saveData = (cart) => {
    localStorage.setItem("cart", JSON.stringify(cart));
  };

  switch (action.type) {
    case ADD_TO_CART:
      // update quantity of already added item
      if (existingIndex !== -1) {
        console.log("Item already in cart, updating quantity...");
        //console.log("newCart[existingIndex].qty:", existingIndex);
        //console.log("action.payloadd.qty:", action.payload.qty);
        let newQty = newCart[existingIndex].qty + action.payload.qty;
        console.log("newQty:", newQty);
        // For subscriptions, also update subscription.quantity
        if (
          newCart[existingIndex].subscription &&
          action.payload.subscription
        ) {
          newCart[existingIndex].subscription.quantity = newQty;
        }

        // update already added item's quantity
        newCart[existingIndex] = { ...newCart[existingIndex], qty: newQty };
        //console.log("Updated item in cart:", newCart[existingIndex]);
      } else {
        // add new item
        newCart.push(action.payload);
      }

      // save cart
      saveData(newCart);
      return newCart;

    case SUBTRACT_FROM_CART:
      if (action.payload) {
        const existingIndex = state.findIndex((item) => {
          const sameVariant = item.variant.id === action.payload.variant.id;
          const itemHasSub = !!item.subscription;
          const payloadHasSub = !!action.payload.subscription;
          if (itemHasSub && payloadHasSub) {
            // Never merge subscriptions
            return false;
          }
          if (!itemHasSub && !payloadHasSub) {
            // Merge regular items
            return sameVariant;
          }
          // Otherwise, don't merge
          return false;
        });
        if (existingIndex !== -1) {
          let newCart = [...state];
          let newQty = newCart[existingIndex].qty - action.payload.qty;
          // For subscriptions, also update subscription.quantity
          if (
            newCart[existingIndex].subscription &&
            action.payload.subscription
          ) {
            newCart[existingIndex].subscription.quantity = newQty;
          }
          if (newQty > 0) {
            newCart[existingIndex] = { ...newCart[existingIndex], qty: newQty };
          } else {
            newCart.splice(existingIndex, 1);
          }
          saveData(newCart);
          return newCart;
        }
      }
      return state;

    case REMOVE_FROM_CART:
      if (action.payload) {
        const removeIndex = state.findIndex((item) => {
          const sameVariant = item.variant.id === action.payload.variant.id;
          const itemSub = item.subscription
            ? JSON.stringify(item.subscription)
            : null;
          const payloadSub = action.payload.subscription
            ? JSON.stringify(action.payload.subscription)
            : null;
          return sameVariant && itemSub === payloadSub;
        });
        if (removeIndex !== -1) {
          const updatedCart = [...state];
          updatedCart.splice(removeIndex, 1);
          saveData(updatedCart);
          return updatedCart;
        }
      }
      return state;

    //TODO implement in cartItem.js
    case CHANGE_FREQUENCY:
      newCart[existingIndex].subscription = action.payload.frequency;
      saveData(newCart);
      return newCart;

    case TOGGLE_SUBSCRIPTION:
      //check for existing subscription
      const existingSubscription = !!newCart[existingIndex].subscription; // !! coerce to boolean

      if (existingSubscription) {
        delete newCart[existingIndex].subscription;
      } else {
        newCart[existingIndex].subscription = action.payload.frequency;
      }

      saveData(newCart);
      return newCart;

    case CLEAR_CART:
      // remove cart from local storage
      localStorage.removeItem("cart");
      console.log("cart cleared.");
      return [];

    default:
      return state;
  }
}
